// ─────────────────────────────────────────────
//  useFacility — real-time facility document for a facility id.
//
//  The Facility Settings page reads the whole facility doc (name, address,
//  contacts, specialties, isActive) and re-renders live as it is edited. A
//  thin wrapper over listenToFacility so the page doesn't manage its own
//  snapshot wiring. Returns { facility, loading } — facility is null until the
//  first snapshot resolves (or if the doc doesn't exist yet, e.g. an empty
//  shell that has never been saved).
// ─────────────────────────────────────────────
import { useEffect, useState } from "react";
import { listenToFacility } from "../firebase/firestore";

export function useFacility(facilityId) {
  const [facility, setFacility] = useState(null);
  const [loading, setLoading]   = useState(true);

  useEffect(() => {
    if (!facilityId) { setFacility(null); setLoading(false); return; }
    setLoading(true);
    const unsub = listenToFacility(
      facilityId,
      (snap) => {
        setFacility(snap.exists() ? { id: snap.id, ...snap.data() } : null);
        setLoading(false);
      },
      () => { setFacility(null); setLoading(false); }
    );
    return unsub;
  }, [facilityId]);

  return { facility, loading };
}
